<template>
  <div>
    <ul>
      <li class="clearfix" v-for="(item,index) in teacherlist.arr" :data-id="item.id" :key="item.id">
        <div class="pic" @click="jumpfunc(item.teacher_id,item.isDelete)">
          <img :src="item.avatar" alt srcset />
        </div>
        <div class="infos">
          <h3>{{item.name}}</h3>
          <div class="nums">
            <em>{{item.courseCount}}</em>门课
            <i>|</i>
            <em>{{item.collectionCount}}</em>人关注
          </div>
          <div class="name"><i>所属机构：</i>{{item.school_name}}</div>
          <div class="fen clearfix fl">
            <div class="rate clearfix fl">
              <span class="fl">讲师评分：</span>
              <el-rate
                v-model="item.score"
                disabled
                show-score
                text-color="#ff1c1c"
                :score-template="(item.score.toString())"
                class="fl"
              ></el-rate>
            </div>
          </div>
          <div class="delate fr" @click="onClose(item.teacher_id)">
            <i class="el-icon-delete"></i>
            删除
          </div>
        </div>
      </li>
    </ul>
    <div class="pageing">
      <span class="spansx" @click="pageindex" :class="[page == 1?'on':'']">首页</span>
      <el-pagination
        small
        layout="prev, pager, next"
        prev-text="上一页"
        next-text="下一页"
        :background="true"
        :total="teacherlist.total_pages==null?1:teacherlist.total_pages"
        :page-size="1"
        @current-change="currentchange"
        :current-page="page"
      ></el-pagination>
      <span @click="pageend" class="spansx" :class="[page == teacherlist.total_pages?'on':'']">尾页</span>
    </div>
  </div>
</template>

<script>
import { Rate, Pagination, Message } from "element-ui";
import utilFile from "@/ace/ace.js";
import getPointNum from "@/tools/tools.js";
export default {
  components: {
    [Rate.name]: Rate,
    [Pagination.name]: Pagination,
    [Message.name]: Message
  },
  data() {
    return {
      value: 3.7,
      page: 1, //教师
      teacherlist: {},
    };
  },
  methods: {
    //分页
    currentchange(page) {
      this.page = page;
    },
    pageindex() {
      this.page = 1;
    },
    pageend() {
      this.page = this.total_pages;
    },
    jumpfunc(teacher_id, isDelete) {
      if (isDelete == 1) {
        Message.closeAll();
        Message({
          showClose: true,
          message: "已下架",
          type: "warning"
        });
      } else {
        this.$router.push({
          path: "/teacherdetails",
          query: {
            id: teacher_id
          }
        });
      }
    },
    onClose(teacher_id) {
      var data = utilFile.encrypt(
        JSON.stringify({
          teacher_id: teacher_id
        })
      );
      this.$axios({
        method: "post",
        url: `/api/user.delTeacherCollection?parameter=${data}`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 200) {
          Message.closeAll();
          Message({
            showClose: true,
            message: res.data.msg,
            type: "success"
          });
          this.teacherlist.arr.forEach((item, index) => {
            if (item.teacher_id == teacher_id) {
              this.teacherlist.arr.splice(index, 1);
            }
          });
        }
      });
    },
    teacher() {
      var data = utilFile.encrypt(
        JSON.stringify({
          page: this.page
        })
      );

      this.$axios({
        method: "post",
        url: `/api/user.teacherCollectionList?parameter=${data}`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 999) {
          this.$router.push({
            path: "/logins"
          });
        } else {
          if (res.data.data != undefined) {
            let arr = JSON.parse(utilFile.decrypt(res.data.data));
            arr.arr.forEach(item => {
              item.score = getPointNum.getPointNum(item.score, 2);
            });
            this.teacherlist = arr;
          }
        }
      });
    }
  },
  mounted() {
    this.teacher();
  }
};
</script>

<style scoped>
ul {
  padding-top: 12px;
}

li {
  padding: 25px 0;
  border-bottom: 1px solid #edf1f2;
}

li .pic {
  width: 142px;
  height: 142px;
  border-radius: 50%;
  overflow: hidden;
  float: left;
}

li .pic img {
  height: 100%;
}

li .infos {
  width: 766px;
  float: right;
  cursor: pointer;
}

li .infos h3 {
  font-size: 18px;
  color: #000;
  margin-bottom: 17px;
  font-weight: bold;
}

li .infos .nums {
  font-size: 14px;
  color: #000;
  margin-bottom: 14px;
}

li .infos .nums em {
  color: red;
}

li .infos .nums i {
  margin: 0 12px;
}

li .infos .name {
  margin-bottom: 30px;
}

li .infos .name i{
  font-weight: bold;
}

li .infos .delate {
  float: right;
  width: 122px;
  line-height: 45px;
  background-color: #f3f4f6;
  color: #000;
  text-align: center;
  font-size: 16px;
}

li .infos .delate i {
  color: #000;
}

li .infos .rate {
  margin-top: 16px;
}

li .infos .rate span{
  font-weight: bold;
}
</style>
<style>
li .infos .rate .el-rate__text {
  font-weight: bold;
}
</style>